/* .profile{
    background-color: white;
    border-radius: 6px;
    width: 100%;
    display: inline-block
}

.profile_name {
    line-height: 18px;
    padding: 20px;
}

.profile_name .name {
    text-transform: uppercase;
    font-size: 17px;
    font-weight: bold;
}

.profile_name .title {
    font-size: 13px;
    color: #777;
}

.profile_image {
    margin-top: -10px;
    clip-path: polygon(0 9%, 100% 0, 100% 94%, 0% 100%);
}

.profile_image img {
    width: 100%;
}

.profile_information {
    top: 0;
    left: 0;
    margin: -30px 10px 30px;
}

.profile_information .timeline .timeline_content {
    margin-top: 2px;
    margin-bottom: 12px;
}

.timelineItem_text {
    font-size: 10px;
    color: #787878;
    font-weight: 400;
    text-decoration: none;
}

.timelineItem_text > a {
    color: #787878;
    text-decoration: none;
}

.timelineItem_text > span {
    color: black;
}

.profile .btn_container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 10px;
} */

const {makeStyles} = require ('@material-ui/core');

const useStyles = makeStyles (theme => ({
  profile: {
    
    color: "#808d9f",
    backgroundColor: "#2d3748",
    boxShadow: '0 3px 3px -5px #2d3748, 0 2px 5px #808d9f',
    borderRadius: 6,
    width: '100%',
    display: 'inline-block',
  },
  profileName: {
    fontFamily: "'Roboto Slab', serif",
    lineHeight: 18,
    padding: 20,
  },
  name: {
    fontFamily: "'Roboto Slab', serif",
    textTransform: 'uppercase',
    fontSize: 17,
    fontWeight: 'bold',
  },
  title: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: 13,
    color: '#bdbdbd',
  },
  profileImage: {
    marginTop: -10,
    clipPath: 'polygon(0 9%, 100% 0, 100% 94%, 0% 100%)',
    boxShadow: '0px 2px 92px 0px rgba(26, 0, 0, 0.13)'
  },
  image: {
    marginTop: 10,
    width: "100%"
  },
  profileInformation: {
    fontFamily: "'Roboto Slab', serif",
    top: 0,
    left: 0,
    margin: '-30px 2px 3px',
  },
  timelineContent: {
    marginTop: 2,
    marginBottom: 12
  },
  timelineItemText: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: 14,
    color: '#bdbdbd',
    fontWeight: 400,
    textDecoration: 'none',
  },
  btnContainer: {
    fontFamily: "'Roboto Slab', serif",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: 10,
    marginBottom: 20
  },
  span: {
    color: "#808d9f"
  },
  a: {
    fontFamily: "'Roboto Slab', serif",
    color: "#bdbdbd",
    textDecoration: "none"
  }
}));

export default useStyles;
